import durometrocb from '../durometrocb/dcb1.png'

const imagendurometrocb = [
    durometrocb,
]

export default imagendurometrocb